module.exports = "/legacy/bd82434dc85e19810002eace49f21eb1.svg";